'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError(err, definedAt) {
  this.Yt = null;
  this.aYi = null;
  this.Yt = err;
  this.aYi = definedAt;
}
export { $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError as $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError };
$p = $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError;
/** @constructor */
function $h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError() {
}
export { $h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError as $h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError };
$h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError) && (this.Yt === x$0.Yt)));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "OnAuthError";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Yt;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "err";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.VM = (function() {
  return this.aYi;
});
function $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kA)));
}
export { $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError as $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError };
var $d_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError, "app.webclient_prelude.components.AppMainModal$OnAuthError", ({
  kA: 1,
  d9: 1,
  cU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError as $d_Lapp_webclient\uff3fprelude_components_AppMainModal$OnAuthError };
//# sourceMappingURL=app.webclient_prelude.components.-App-Main-Modal$-On-Auth-Error.js.map
